import { adapter, initialState, State } from './state';
import { createReducer, on, Action } from '@ngrx/store';
import { clearTrailers, deleteTrailerFailure, deleteTrailerRequest, deleteTrailerSuccess, getTrailerFailure, getTrailerRequest,
    getTrailersFailure, getTrailersRequest, getTrailersSuccess, getTrailerSuccess, removeGuestTrailer, saveGuestTrailer,
    saveTrailerFailure, saveTrailerRequest, saveTrailerSuccess } from './actions';
import { GUEST_USER_ID } from '@services/user.service';

export const trailerReducer = createReducer(
    initialState,
    on(
        getTrailersRequest,
        getTrailerRequest,
        saveTrailerRequest,
        deleteTrailerRequest,
        state => ({
            ...state,
            loading: true,
            error: null
        })
    ),
    on(
        getTrailersFailure,
        getTrailerFailure,
        saveTrailerFailure,
        deleteTrailerFailure,
        (state, { error }) => ({
            ...state,
            loading: false,
            error
        })
    ),

    // Get Trailers
    on(
        getTrailersSuccess,
        (state, { trailers }) => adapter.upsertMany(trailers, {
            // Need to use upsertMany instead of setAll in order to not remove the guest trailer (in case of a guest user)
            ...state,
            loading: false,
            error: null,
            total: trailers.length
        })
    ),

    // Get/Save Trailer
    on(
        getTrailerSuccess,
        saveTrailerSuccess,
        saveGuestTrailer,
        (state, { trailer }) => adapter.upsertOne(trailer, {
            ...state,
            loading: false,
            error: null
        })
    ),

    // Delete Trailer
    on(
        deleteTrailerSuccess,
        (state, { id }) => adapter.removeOne(id, {
            ...state,
            loading: false,
            error: null
        })
    ),

    // Clear Trailers
    on(
        clearTrailers,
        (state) => adapter.removeAll({
            ...state,
            loading: false,
            error: null
        })
    ),

    // Remove Guest Trailer
    on(
        removeGuestTrailer,
        (state) => adapter.removeOne(GUEST_USER_ID, {
            ...state,
            loading: false,
            error: null
        })
    ),
);

export function reducer(state: State, action: Action) {
    return trailerReducer(state, action);
}
